export class ConfirmRecoverRequest {
    userName: string = "";
    resetToken: string = "";
    password: string = "";
    confirmPassword: string = "";
    resetMethod: number = 0;
}
